import HumanDate from './HumanDate';

export default (value = 'now') => HumanDate(value, 'server');
